/*globals Swiper*/

import CookieSet from 'common/util/CookieSet';
import HistoryUtil from 'common/util/HistoryUtil';
import './compare-page-m.scss';

class ComparePageMobile {
	static select = $context => $context.select('.compare-page-m');

	_filter = '';

	constructor($page) {
		this.$page = $page;
		this.CompareSet = CookieSet('shop_compare');

		this.bindEvents();
		this.initSwiper();
	}

	get filter() {
		return this._filter;
	}

	set filter(filter) {
		this._filter = filter;
		this.$page.trigger('compare_change_filter', filter);
	}

	bindEvents() {
		const self = this;

		self.$page.on('change', '.compare-page-m__type-select', function() {
			const $type_select = $(this);
			const type = $type_select.val();

			self.handleChangeTypeSelect(type);
		});

		self.$page.find('.compare-page-m__mode-control').on('change', function() {
			self.$page.toggleClass('compare-page-m_same', $(this).prop('checked'));
		});

		self.$page.on('click', '.compare-page-m__product-delete-button-container', function() {
			const id = $(this).data('product_id');

			self.deleteItem(id);
		});

		self.$page.on('click', '.compare-page-m__delete', function() {
			self.deleteAllItems();
		});

		$(window).on('scroll', this.handleScroll);
	}

	initSwiper() {
		const self = this;

		this.$page.find('.compare-page-m__products-slider-container').each(function() {
			var $slider = $(this);
			var index = $(this).data('index');
			$slider.addClass('compare-page-m__products-slider-container_swiper');

			var swiper = new Swiper($slider.get(0), {
				init: false,
				wrapperClass: 'compare-page-m__products-slider',
				slideClass: 'compare-page-m__product',
				spaceBetween: 0,
				slidesPerView: 1,
				watchSlidesVisibility: true,
				watchSlidesProgress: true,
				initialSlide: index,
				runCallbacksOnInit: true
			});

			$slider.data('swiper', swiper);

			swiper.on('slideChange', function() {
				var slide = swiper.slides[swiper.activeIndex];
				var features = $(slide).data('features');
				var price_html = $(slide).data('price_html');

				self.$page.find('.compare-page-m__price-value_index_' + index).each(function() {
					$(this).html(price_html);
				});

				self.$page.find('.compare-page-m__feature-value_index_' + index).each(function() {
					var feature_code = $(this).data('feature_code');
					$(this).html(features[feature_code]);
				});

				self.$page.find('.compare-page-m__slider-index_index_' + index).each(function() {
					$(this).html(
						swiper.activeIndex +
							1 +
							'/<span class="compare-page-m__products-count compare-page-m__products-count_normal">' +
							swiper.slides.length +
							'</span>'
					);
				});
			});

			swiper.init();
		});
	}

	deleteAllItems() {
		const self = this;
		$('.compare-page-m__product').each(function() {
			const id = $(this).data('id');
			self.CompareSet.remove(id);
			HistoryUtil.reloadWithoutQuery();
		});
	}

	deleteItem(id) {
		this.CompareSet.remove(id);

		HistoryUtil.reloadWithoutQuery();
	}

	handleChangeTypeSelect(type) {
		location.href = `?type=${type}`;
	}

	handleScroll = () => {
		const $header = this.$page.find('.compare-page-m__products-container');

		if ($header.length === 0) {
			return;
		}

		const is_fixed = $header.offset().top <= window.scrollY + 60;

		this.$page.toggleClass('compare-page-m_fixed', is_fixed);
	};
}

export default () => Component(ComparePageMobile.select, $page => new ComparePageMobile($page));
